export default {
    byVacancy(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('vacancyId', id).get()
            )
        )
    }
}
